// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'mcp';

export const Component = () => (
  <g fill='currentColor'>
    <path d='M8.182.916a3.069 3.069 0 0 1 4.375 0 3.145 3.145 0 0 1 .875 2.655A3.067 3.067 0 0 1 16 4.4l.058.056.036.037.055.058a3.154 3.154 0 0 1-.055 4.367l-6.331 6.404a.21.21 0 0 0 0 .295l1.3 1.315c.241.244.241.64 0 .885s-.634.244-.875 0l-1.3-1.316a1.471 1.471 0 0 1 0-2.064l6.33-6.404a1.892 1.892 0 0 0 0-2.655l-.035-.036-.035-.034a1.842 1.842 0 0 0-2.59.034L7.27 10.688a.614.614 0 0 1-.875 0 .63.63 0 0 1 0-.885l5.287-5.347a1.893 1.893 0 0 0 0-2.655 1.842 1.842 0 0 0-2.625 0l-7 7.08a.614.614 0 0 1-.876 0 .631.631 0 0 1 0-.885z' />
    <path d='M9.932 2.687a.614.614 0 0 1 .875 0 .63.63 0 0 1 0 .884L5.629 8.808l-.127.142a1.893 1.893 0 0 0 .127 2.513l.141.128a1.84 1.84 0 0 0 2.485-.128l5.177-5.236a.614.614 0 0 1 .875 0 .63.63 0 0 1 0 .884L9.13 12.348a3.07 3.07 0 0 1-4.318.057l-.058-.057a3.155 3.155 0 0 1 0-4.425z' />
  </g>
);

export const viewBox = '0 0 18 18';
